import { prop } from '@gov-nx/core/types';
import { usePersistedStore } from '../constants';
import type { AppState } from './store.types';

export enum OfflineDataDownloadState {
	Init = 'init',
	Enabled = 'enabled',
	Disabled = 'disabled',
}

const initialState = {
	lastActivityTime: 0,
	pushNotificationWindowShown: false,
	offlineDataDownloadState: OfflineDataDownloadState.Init,
	dismissedAlertIds: [],
	hasHydrated: false,
};

const useStore = <T>(selector: (state: AppState) => T) =>
	usePersistedStore(
		(set) => ({
			...initialState,

			saveLastActivityTime: (lastActivityTime: number) =>
				set({ lastActivityTime }),

			setPushNotificationWindowShown: (pushNotificationWindowShown: boolean) =>
				set({ pushNotificationWindowShown }),

			setOfflineDataDownloadState: (
				offlineDataDownloadState: OfflineDataDownloadState
			) => set({ offlineDataDownloadState }),
			setDismissedAlertIds: (dismissedAlertIds: number[]) =>
				set({ dismissedAlertIds }),
			setHasHydrated: (hasHydrated: boolean) => set({ hasHydrated }),

			appReset: () => set(initialState),
		}),
		'app',
		selector,
		{
			onRehydrateStorage: (state) => () => state.setHasHydrated(true),
		}
	);

export const useAppStore = <T extends keyof AppState>(
	property: T
): AppState[T] => useStore(prop(property));
